module.exports = __webpack_public_path__ + "img/video.2bd8c06b.png";